import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { CertificateDto } from '@api/models/suppliers/CertificateDto';
import { certificateService } from '@api/services/services';

export interface CertificateListFilter extends ListFilter {
  state?: EntityState;
}

export type CertificateListState = ListType<CertificateDto, CertificateListFilter>;

const createCertificateList = (name: 'certificateList' | 'activityCertificateList', state?: EntityState) => {
  const slice = listSlice<CertificateDto, CertificateListFilter>({
    name,
    initialState: {
      state: FetchState.None,
      data: undefined,
      query: { state, sortBy: 'name', sortDesc: false },
    },
  });

  const getData = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const data: CertificateListState = store.getState()[name];

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: slice.actions,
      getData: (size: number) =>
        certificateService.query(
          {
            q: data.query.q,
            state: data.query.state,
            page: data.query.page,
            size: size,
            sort: getListSort(data),
          },
          { cancelToken: cancelToken },
        ),
    });
  };

  return { slice, getData };
};

// Certificates page: filtered by state (active by default).
const certificateList = createCertificateList('certificateList', EntityState.Active);

export const certificateListSlice = certificateList.slice;
export const selectCertificateList = (state: RootState) => state.certificateList;
export const certificateListActions = certificateListSlice.actions;
export const getCertificateList = certificateList.getData;

// Activity detail picker: always active certificates, independent of the certificates page filter.
const activityCertificateList = createCertificateList('activityCertificateList', EntityState.Active);

export const activityCertificateListSlice = activityCertificateList.slice;
export const selectActivityCertificateList = (state: RootState) => state.activityCertificateList;
export const activityCertificateListActions = activityCertificateListSlice.actions;
export const getActivityCertificateList = activityCertificateList.getData;
